(ns iris.events
  (:require
   [re-frame.core :as re-frame]
   ;;  [re-pressed.core :as rp]
   [iris.db :as db]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [ajax.core :as ajax]
   [iris.utils :as utils]

   [iris.cookie]
   [iris.globals :as globals]
   [goog.crypt.base64 :as b64]))



;; ;; 1. Define a global interceptor
;; (def log-every-event
;;   (re-frame/->interceptor
;;     :id :log-every-event
;;     :before (fn [context]
;;               (let [event (get-in context [:coeffects :event])]
;;                 (js/console.log "Intercepted event:" (clj->js event)))
;;               context)))

;; ;; 2. Register the interceptor globally
;; (re-frame/reg-global-interceptor log-every-event)







(re-frame/reg-event-db
 ::initialize-db
 (fn-traced [_ _]
            db/default-db))

(re-frame/reg-event-fx
 ::navigate
 (fn-traced [_ [_ handler]]
            {:navigate handler}))

(re-frame/reg-event-fx
 ::route-to
 (fn-traced [_ [_ route-str]]
            {:route-to route-str}))


(re-frame/reg-event-fx
 ::route-to-replace
 (fn-traced [_ [_ route-str]]
            {:route-to-replace route-str}))


(re-frame/reg-event-fx
 ::set-active-panel
 (fn-traced [{:keys [db]} [_ active-panel]]
            {:db (assoc db :active-panel active-panel)
             ;;  :dispatch [::rp/set-keydown-rules
             ;;             {:event-keys [[[::set-re-pressed-example "Hello, world!"]
             ;;                            [{:keyCode 72} ;; h
             ;;                             {:keyCode 69} ;; e
             ;;                             {:keyCode 76} ;; l
             ;;                             {:keyCode 76} ;; l
             ;;                             {:keyCode 79}]]] ;; o

             ;;              :clear-keys
             ;;              [[{:keyCode 27}]]}]
             }));; escape


(re-frame/reg-event-fx
 ::set-route
 (fn-traced [{:keys [db]} [_ route]]
            (let [prev-route (:route db)]
              ;; {:db (assoc db :route route)}
              {:db (-> db
                       (assoc :route route)
                       (assoc :prev-route prev-route))})))


(re-frame/reg-event-db
 ::set-re-pressed-example
 (fn [db [_ value]]
   (assoc db :re-pressed-example value)))



;; (re-frame/reg-event-db
;;  ::get-jwt-success
;;  (fn [db [_ data]]
;;    (println "jwt::" data)
;;    (assoc-in db [:jwt] data)))

;; (re-frame/reg-event-db
;;  ::get-jwt-failure
;;  (fn [db]
;;    (println "get jwt failure")
;;    (assoc-in db [:censors :message] "Get JWT failure!")))


;; (re-frame/reg-event-fx
;;  ::get-jwt
;;  (fn [e [_]]
;;    {:http-xhrio {:method          :get
;;                  :uri             (str (. js/location -origin) "/get-jwt")
;;                  :timeout         8000                                           ;; optional see API docs
;;                  :response-format (ajax/text-response-format)  ;; IMPORTANT!: You must provide this.
;;                  :on-success      [::get-jwt-success]
;;                  :on-failure      [::get-jwt-failure]}}))

(re-frame/reg-event-db
 ::set-mobile
 (fn [db [_ mobile]]
   (assoc db :mobile mobile)))

(re-frame/reg-event-db
 ::set-viewport-size
 (fn [db [_ x y]]
   (assoc db :viewport-size {:x x :y y})))

(re-frame/reg-event-db
 ::set-scroll-top
 (fn [db [_ value]]
   (assoc db :scroll-top value)))

(re-frame/reg-event-db
 ::set-fp
 (fn [db [_ value]]
 (println "::set-fp" value)
   (assoc db :fp value)))

(re-frame/reg-event-db
 ::set-dfp
 (fn [db [_ value]]
   (assoc db :dfp value)))

(re-frame/reg-event-db
 ::set-loading
 (fn [db [_ value]]
   (assoc db :loading value)))

(re-frame/reg-event-db
 ::set-jwt-payload
 (fn [db [_ value]]
   (assoc db :jwt-payload value)))

(re-frame/reg-event-db
 ::set-fb-user
 (fn [db [_ value]]
   (assoc db :fb-user value)))

(re-frame/reg-event-db
 ::set-fb-auth-state
 (fn [db [_ value]]
   ;;  NOTE: if nil and new value is false, leave as is.
   ;;  used for displaying fb signed out message
   ;;  onAuthChange first reports false then true
   (if (and (nil? (:fb-auth-state db)) (false? value))
     db
     (assoc db :fb-auth-state value))))

(re-frame/reg-event-db
 ::set-raids-cache-id
 (fn [db [_ value]]
   (assoc db :raids-cache-id value)))

(re-frame/reg-event-db
 ::set-raidpurger
 (fn [db [_ value]]
   (assoc db :raidpurger value)))

(re-frame/reg-event-db
 ::set-raid-len
 (fn [db [_ value]]
   (assoc db :raid-len value)))

(re-frame/reg-event-db
 ::set-roles
 (fn [db [_ value]]
   (assoc db :roles value)))

;; (re-frame/reg-event-db
;;  ::track-request
;;  (fn [db [_ id xhrio]]
;;    (println "from ::track-request" id xhrio)
;;    (when-let [rq (get-in db [:requests id])]
;;      (ajax/abort rq))
;;    (assoc-in db [:requests id] xhrio)))
(re-frame/reg-event-db
 ::track-request
 (fn [db [_ id xhrio]]
   db))

;; TODO: request handler is passed as vector - this is needed in case you want to pass some parameters to the handler function. it would be best if all handlers (success, failure) would be done this way
(defn post-rpc
  ([body success-handler failure-handler]
   (post-rpc body success-handler failure-handler nil))
  ([body success-handler failure-handler request-handler]
   (re-frame/dispatch [::set-loading true])
   (let [jwt @globals/jwt
         json (utils/clj->json body)]
     {:http-xhrio (merge {:method :post
                          ;; :uri (str (utils/get-service-url "apollo") "/rpc")
                          :uri js/apolloURL
                          :body json
                          :timeout 60000
                          :headers {"Authorization" (str "Bearer " jwt)
                                    "Content-Type" "application/json; charset=UTF-8"}
                          :response-format (ajax/json-response-format {:keywords? true})
                          :on-success success-handler
                          :on-failure failure-handler}
                         (when (some? request-handler)
                           {:on-request request-handler}))})))




;; track request, cancel previous
;; (re-frame/reg-event-db
;;  ::track-slow-request
;;  (fn [db [_ my-id xhrio]]
;;   ;;  (.dispose xhrio)
;;   ;;  (.log js/console xhrio)
;;    (println "rq page:" (:page my-id))
;;    (.log js/console (get-in db [:requests (:id my-id)]))
;;    (when-let [rq (get-in db [:requests (:id my-id)])]
;;     ;;  (.dispose rq)
;;     ;;  (.abort rq)
;;      (ajax/abort rq))
;;    (.log js/console (get-in db [:requests (:id my-id)]))
;;    (assoc-in db [:requests (:id my-id)] xhrio)))





;; debounce event
(defonce debounce-timeouts (atom {}))

(re-frame/reg-fx
 ::dispatch-debounce
 (fn [[id event-vec n]]
   (js/clearTimeout (@debounce-timeouts id))
   (swap! debounce-timeouts assoc id
          (js/setTimeout (fn []
                           (re-frame/dispatch event-vec)
                           (swap! debounce-timeouts dissoc id))
                         n))))




(re-frame/reg-fx
 :reset-form
 (fn [form]
   (.reset (.getElementById js/document form))))


(re-frame/reg-event-fx
 ::reset-form
 (fn-traced [_ [_ form]]
            {:reset-form form}))


;; (re-frame/reg-event-fx
;;  ::get-jwt
;;  [(re-frame/inject-cofx :cookie/get "jwt")]
;;  (fn [{:keys [db] :as cofx} [e]]
;;    (println "cofx::" (:jwt cofx))))


;; (re-frame/reg-event-fx
;;  ::validate-jwt
;;  [(re-frame/inject-cofx :cookie/get "jwt")]
;;  (fn [{:keys [db] :as cofx} [e]]
;;    (println "cofx::" (:jwt cofx))
;;    {:navigate :login}))





(re-frame/reg-event-db
 ::popup-alerts
 (fn [db [_ value]]
   (assoc-in db [:alerts :popup] value)))

(re-frame/reg-event-db
 ::set-alerts
 (fn [db [_ value]]
   ;;  (assoc db :alerts value)
   (assoc-in db [:alerts :data] value)))

(re-frame/reg-event-db
 ::set-alerts-show-all
 (fn [db [_ value]]
   (assoc-in db [:alerts :show-all] value)))

(re-frame/reg-event-db
 ::remove-alert
 (fn [db [_ id]]
   (assoc-in db [:alerts :data] (filterv #(not= (:id %) id) (get-in db [:alerts :data])))))




;; NOTE: "set-ws" event is a temp solution, used only by globals/exec-on-fb-sign-in from core.cljs to restore the last used (default) ws from firebase
;; In the future the idea is to raise :ws to the top most level (above :posts)
(re-frame/reg-event-db
 ::set-ws
 (fn [db [_ value]]
   ;;  (assoc-in db [:posts :ws] value)
   (assoc-in db [:ws] value)))

;; used for firebase default ws sync, switching to local storage
(re-frame/reg-event-db
 ::set-ws-sync
 (fn [db [_ value]]
   (-> db
       ;;  (assoc-in [:posts :ws] value)
       (assoc-in [:ws] value)
       ;;  (assoc-in [:posts :ws-sync] true)
       (assoc-in [:ws-sync] true))))


(re-frame/reg-event-db
 ::set-message
 (fn [db [_ value]]
   (assoc-in db [:message] value)))

(re-frame/reg-event-db
 ::toggle-show-moderator-logs
 (fn [db [_]]
   (assoc-in db [:show-moderator-logs] (not (:show-moderator-logs db)))))

(re-frame/reg-event-db
 ::set-show-moderator-logs
 (fn [db [_ value]]
   (assoc-in db [:show-moderator-logs] value)))

(re-frame/reg-event-db
 ::toggle-show-search-bar
 (fn [db [_]]
   (assoc-in db [:show-search-bar] (not (:show-search-bar db)))))



;; # JobKws ruid -timeUpdated
;; - kind: JobKws
;;   properties:
;;   - name: ruid
;;   - name: timeUpdated
;;     direction: desc

;; 'JobKws.Get': 'get_jobkws',
;; 'JobKws.GetHistory': 'get_jobkws_history',
;; 'JobKws.Submit': 'submit_jobkws',

;;   # JobKws ---
;;   def get_jobkws(self, ruid=None):
;;       # query JobKws
;;       # filter by ruid
;;       # order by timeUpdated
;;       # return first result
;;       qry = self.ds.query_jobkws(ruid)
;;       return qry.get()

;;   def get_jobkws_history(self, ruid=None):
;;       # same as above but return all results
;;       qry = self.ds.query_jobkws(ruid)
;;       return qry.fetch()

;;   def submit_jobkws(self, ruid=None, keywords_input=None):
;;       e = JobKws(ruid=ruid, keywords_input=keywords_input)
;;       now = datetime.datetime.now()
;;       uid = self.rq.usr.uid()
;;       last = self.get_jobkws(ruid)
;;       if last:
;;           e.time_created = last.time_created
;;           e.who_created = last.who_created
;;       else:
;;           e.time_created = now
;;           e.who_created = uid
;;       e.time_updated = now
;;       e.who_updated = uid
;;       s = punct_to_spaces(e.keywords_input).strip()
;;       e.keywords_input = s
;;       if e.keywords_input:
;;           e.keywords = e.keywords_input.split()
;;       self.ds.put(e)

;; def punct_to_spaces(s):
;;   PUNCT = [',', ';']
;;   for p in PUNCT:
;;       s = s.replace(p, ' ')



(re-frame/reg-event-db
 ::http-get-job-keywords-success
 (fn [db [_ ruid data]]
   ;;  (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::set-loading false])

   (if-let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:job-keywords (keyword ruid)] result-data))
     db)))


(re-frame/reg-event-db
 ::http-get-job-keywords-failure
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   (-> db
       ;;  (assoc-in [:posts :message] "API connection failure!")
       (assoc-in [:message] "API connection failure!"))))


(re-frame/reg-event-fx
 ::http-get-job-keywords
 (fn [e [_ ruid]]
   (post-rpc {:jsonrpc "2.0"
              :id 0
              :method "JobKws.Get"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-get-job-keywords-success ruid]
             [::http-get-job-keywords-failure])))



(re-frame/reg-event-db
 ::http-get-job-keywords-history-success
 (fn [db [_ ruid data]]
   ;;  (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::set-loading false])

   ;;  (if-let [result-data (get-in data [:result :data])]
   (if-let [result-data (get-in data [:result :data])]
     (-> db
         (assoc-in [:job-keywords (keyword ruid)] result-data))
     db)))

(re-frame/reg-event-db
 ::http-get-job-keywords-history-failure
 (fn [db]
   (re-frame/dispatch [::http-complete])
   ;;this will not work - this gets triggered on http fail - not not being able to pull record, we still get valid response
   (-> db
       ;;  (assoc-in [:posts :message] "API connection failure!")
       (assoc-in [:message] "API connection failure!"))))

(re-frame/reg-event-fx
 ::http-get-job-keywords-history
 (fn [e [_ ruid]]
   (post-rpc {:jsonrpc "2.0"
              :id 0
              :method "JobKws.GetHistory"
              :params {:options {:debug false}
                       :data ruid}}
             [::http-get-job-keywords-history-success ruid]
             [::http-get-job-keywords-history-failure])))








(re-frame/reg-event-db
 ::http-job-keywords-submit-success
 (fn [db [_ ruid data]]
   ;;  (re-frame/dispatch [::http-complete])
   (re-frame/dispatch [::set-loading false])

   (when-let [result-data (get-in data [:result :data])]
     (re-frame/dispatch [::http-get-job-keywords-history ruid]))

   (set! (.-value (.getElementById js/document "location-input")) "")
   (set! (.-value (.getElementById js/document "kws-input")) "")

   (-> db
       (assoc-in [:message] (get-in data [:result :message])))))


(re-frame/reg-event-db
 ::http-job-keywords-submit-failure
 (fn [db]
   (re-frame/dispatch [::http-complete])
   (-> db
       ;;  (assoc-in [:posts :message] "API connection failure!")
       (assoc-in [:message] "API connection failure!"))))


(re-frame/reg-event-fx
 ::http-job-keywords-submit
 (fn [e [_ ruid kws-input location-input]]
   (post-rpc {:jsonrpc "2.0"
              :id 0
              :method "JobKws.Submit"
              :params {:options {:debug false}
                       :data {:ruid ruid
                              :keywords kws-input
                              :location location-input}}}
             [::http-job-keywords-submit-success ruid]
             [::http-job-keywords-submit-failure])))


(def redo-interceptor
  (re-frame/->interceptor
   :id :redo
   :before (fn [context] ;; we take the interceptor context
             ;;  redo key - take the current route object and base64 it, assign events to be redone under it
             ;;  when the route changes, scrap the current values in atom and assign new ones under the new redo key
             (let [k (keyword (b64/encodeString (-> context :coeffects :db :route)))]
               (if-let [redo-events (k @globals/redo)]
                 (do
                   ;;  destructure the new event into event (ne) and params (np)
                   ;;  filter the already assigned events in redo atom to make sure the same event isn't already there
                   ;;  add the new event to filtered list of redo events and assign it back to atom
                   (let [[ne np] (-> context :coeffects :event)]
                     (let [filtered-redo-events (filter (fn [[e p]] (not= e ne)) redo-events)]
                       (let [new-redo-events (conj filtered-redo-events (-> context :coeffects :event))]
                         (swap! globals/redo #(assoc-in @globals/redo [k] new-redo-events))))))
                 (do
                   ;;  no redo events found under this key (k), init new redo event list
                   (swap! globals/redo #(assoc-in {} [k] (list (-> context :coeffects :event))))))
               (println "after redo-events update @globals/redo:" @globals/redo))
             context))) ;; return the context unmodified


(re-frame/reg-event-fx
 ::redo
 (fn [_ _]
   (let [redo-val @globals/redo]
     (if (empty? redo-val)
       (do
         (println "No redo events but :redo was dispatched.")
         {}) ;; return no effects
       (do
         ;; destructuring map with an unknown key
         ;; get keys (list) and return first from the list - k
         ;; use k to get the list of events to be dispatched/redone from redo atom
         (let [k (-> redo-val keys first)
               events (k @globals/redo)]
           (doseq [e events]
             (re-frame/dispatch e)))
         {}) ;; return no effects
       ))))




(defn api-msg-interceptor
  [{:keys [result-modifier-fn
           error-modifier-fn
           debug-message-modifier-fn
           mute-keys
           id]
    :or   {result-modifier-fn identity
           error-modifier-fn identity
           debug-message-modifier-fn identity
           mute-keys #{}}}]
  (re-frame.core/->interceptor
   :id     (or id :api-msg-interceptor)
   :before (fn [context]
             ;; store the original db so it's accessible in :after (note: needed for -fx events)
             (if-let [db (get-in context [:coeffects :db])]
               (assoc-in context [:api-msg-interceptor :original-db] db)
               context))
   :after  (fn [context]
             (letfn [(now-ts [] (.getTime (js/Date.)))

                     (get-m-from-kv [k v]
                       (when-not (contains? mute-keys k)
                         (let [msg (case k
                                     :result        (result-modifier-fn (:message v))
                                     :error         (error-modifier-fn (:message v))
                                     :debug-message (debug-message-modifier-fn v))]
                           {:ts (now-ts)
                            k   msg})))

                     (set-m-in-context [context m]
                       (let [handler-db  (get-in context [:effects :db])
                             fallback-db (get-in context [:api-msg-interceptor :original-db])
                             db          (or handler-db fallback-db)]

                         (if db
                           (let [old-msgs      (get-in db [:messages])
                                 prev-msg      (first old-msgs)
                                 prev-ts       (:ts prev-msg)
                                 new-ts        (:ts m)
                                 within-3s     (and prev-ts
                                                    (<= (js/Math.abs (- new-ts prev-ts)) 3000))
                                 new-more-msgs (if within-3s
                                                 (inc (get-in db [:message-bar :more-msgs] 0))
                                                 0)
                                 updated-db    (-> db
                                                   (update :messages #(->> (cons m (or % []))
                                                                           (take globals/MESSAGES_LIMIT)
                                                                           vec))
                                                   (assoc-in [:message-bar :more-msgs] new-more-msgs)
                                                   (assoc-in [:message-bar :mode] :latest)  ;; <- added to display latest on new message arrival
                                                   (assoc-in [:message-bar :index] 0) ;; <- added to display latest on new message arrival
                                                   (assoc-in [:message-bar :expanded?] false) ;; <- added to display latest on new message arrival
                                                   )]
                             (assoc-in context [:effects :db] updated-db))
                           context)))]

               (let [event (get-in context [:coeffects :event])
                     [k v] (utils/find-first-matching-key event #{:result :error :debug-message})]
                 (if-let [m (get-m-from-kv k v)]
                   (set-m-in-context context m)
                   context))))))


;; (re-frame/reg-event-db
;;  ::add-msg
;;  (fn [db [_ msg]]
;;    (let [now-ts (.getTime (js/Date.))] ; Unix timestamp in ms
;;      (update-in db [:messages]
;;                 (fnil #(->> (cons (assoc msg :ts now-ts) %)
;;                             (take globals/MESSAGES_LIMIT)
;;                             vec)
;;                       [])))))


(re-frame/reg-event-db
 ::add-msg
 (fn [db [_ msg]]
   (let [now-ts (.getTime (js/Date.))
         old-msgs      (get-in db [:messages])
         prev-msg      (first old-msgs)
         prev-ts       (:ts prev-msg)
         new-ts        now-ts
         within-3s     (and prev-ts
                            (<= (js/Math.abs (- new-ts prev-ts)) 3000))
         new-more-msgs (if within-3s
                         (inc (get-in db [:message-bar :more-msgs] 0))
                         0)]
     (-> db
         (update-in [:messages]
                    (fnil #(->> (cons (assoc msg :ts now-ts) %)
                                (take globals/MESSAGES_LIMIT)
                                vec)
                          []))
         (assoc-in [:message-bar :more-msgs] new-more-msgs)
         (assoc-in [:message-bar :mode] :latest) ;; <-- added to display latest on new message arrival
         (assoc-in [:message-bar :index] 0) ;; <-- added to display latest on new message arrival
         (assoc-in [:message-bar :expanded?] false) ;; <-- added to display latest on new message arrival
         ))))  



;; This was an attempt to add reagent component as component key in messages, can get rid of
;; (re-frame/reg-event-db
;;  ::add-msg
;;  (fn [db [_ msg & [component]]]
;;    (let [now-ts (.getTime (js/Date.))
;;          msg-entry (cond-> (assoc msg :ts now-ts)
;;                      component (assoc :component component))]
;;      (update-in db [:messages]
;;                 (fnil #(->> (cons msg-entry %)
;;                             (take globals/MESSAGES_LIMIT)
;;                             vec)
;;                       [])))))



(re-frame/reg-event-db
 ::message-bar-set-mode
 (fn [db [_ mode]]
   (assoc-in db [:message-bar :mode] mode)))

(re-frame/reg-event-db
 ::message-bar-set-index
 (fn [db [_ idx]]
   (assoc-in db [:message-bar :index] idx)))

(re-frame/reg-event-db
 ::message-bar-set-expanded?
 (fn [db [_ val]]
   (assoc-in db [:message-bar :expanded?] val)))

(re-frame/reg-event-db
 ::message-bar-toggle-expanded?
 (fn [db _]
   (update-in db [:message-bar :expanded?] not)))